{
  "asOf": "2026-07-14",
  "rankingsAsOf": "2026-07-14T08:32:31.569Z",
  "benchmarkAsOf": "2026-07-14T00:00:48.065Z",
  "benchmarkCitation": "Source: Artificial Analysis (artificialanalysis.ai) via OpenRouter (openrouter.ai/rankings).",
  "benchmarkMethod": "current-aa-rescored-history",
  "standardCall": {
    "inputTokens": 10000,
    "outputTokens": 1500
  },
  "history": [
    {
      "month": "2025-01",
      "totalTokensT": 2.230133,
      "leaderModelId": "anthropic/claude-3.5-sonnet:beta",
      "leaderModelLabel": "Claude 3.5 Sonnet Beta",
      "leaderSharePct": 27.8097,
      "top5SharePct": 64.6476,
      "tailSharePct": 3.8613,
      "rankedModelCount": 90,
      "dailyLeaderCount": 2,
      "firstEntryTokenSharePct": null,
      "publicAppTokensPerRequest": null,
      "publicAppRequests": null,
      "publicAppCount": null,
      "weightedIntelligenceIndex": null,
      "intelligenceCoveragePct": 3.9311,
      "standardCallCostUsd": null,
      "weightedInputPricePerMillionUsd": null,
      "weightedOutputPricePerMillionUsd": null,
      "priceCoveragePct": 6.0696
    },
    {
      "month": "2025-02",
      "totalTokensT": 3.496567,
      "leaderModelId": "anthropic/claude-3.5-sonnet",
      "leaderModelLabel": "Claude 3.5 Sonnet (Oct '24)",
      "leaderSharePct": 20.3633,
      "top5SharePct": 58.3502,
      "tailSharePct": 4.3058,
      "rankedModelCount": 88,
      "dailyLeaderCount": 2,
      "firstEntryTokenSharePct": 26.6291,
      "publicAppTokensPerRequest": null,
      "publicAppRequests": null,
      "publicAppCount": null,
      "weightedIntelligenceIndex": null,
      "intelligenceCoveragePct": 4.0505,
      "standardCallCostUsd": null,
      "weightedInputPricePerMillionUsd": null,
      "weightedOutputPricePerMillionUsd": null,
      "priceCoveragePct": 6.501
    },
    {
      "month": "2025-03",
      "totalTokensT": 6.314286,
      "leaderModelId": "anthropic/claude-3-7-sonnet-20250219",
      "leaderModelLabel": "Claude 3 7 Sonnet 20250219",
      "leaderSharePct": 21.2594,
      "top5SharePct": 54.6217,
      "tailSharePct": 3.4776,
      "rankedModelCount": 86,
      "dailyLeaderCount": 2,
      "firstEntryTokenSharePct": 4.8227,
      "publicAppTokensPerRequest": null,
      "publicAppRequests": null,
      "publicAppCount": null,
      "weightedIntelligenceIndex": null,
      "intelligenceCoveragePct": 8.3134,
      "standardCallCostUsd": null,
      "weightedInputPricePerMillionUsd": null,
      "weightedOutputPricePerMillionUsd": null,
      "priceCoveragePct": 10.2107
    },
    {
      "month": "2025-04",
      "totalTokensT": 8.294859,
      "leaderModelId": "anthropic/claude-3-7-sonnet-20250219",
      "leaderModelLabel": "Claude 3 7 Sonnet 20250219",
      "leaderSharePct": 18.203,
      "top5SharePct": 48.6218,
      "tailSharePct": 4.0627,
      "rankedModelCount": 89,
      "dailyLeaderCount": 4,
      "firstEntryTokenSharePct": 16.5814,
      "publicAppTokensPerRequest": null,
      "publicAppRequests": null,
      "publicAppCount": null,
      "weightedIntelligenceIndex": null,
      "intelligenceCoveragePct": 9.1327,
      "standardCallCostUsd": null,
      "weightedInputPricePerMillionUsd": null,
      "weightedOutputPricePerMillionUsd": null,
      "priceCoveragePct": 15.5826
    },
    {
      "month": "2025-05",
      "totalTokensT": 9.861178,
      "leaderModelId": "openai/gpt-4o-mini",
      "leaderModelLabel": "GPT-4o mini",
      "leaderSharePct": 17.721,
      "top5SharePct": 53.3169,
      "tailSharePct": 5.1867,
      "rankedModelCount": 83,
      "dailyLeaderCount": 2,
      "firstEntryTokenSharePct": 6.1373,
      "publicAppTokensPerRequest": null,
      "publicAppRequests": null,
      "publicAppCount": null,
      "weightedIntelligenceIndex": null,
      "intelligenceCoveragePct": 11.9701,
      "standardCallCostUsd": 0.009133886831336934,
      "weightedInputPricePerMillionUsd": 0.5374698468641812,
      "weightedOutputPricePerMillionUsd": 2.506125575130079,
      "priceCoveragePct": 29.5853
    },
    {
      "month": "2025-06",
      "totalTokensT": 9.676031,
      "leaderModelId": "anthropic/claude-4-sonnet-20250522",
      "leaderModelLabel": "Claude 4 Sonnet (Reasoning)",
      "leaderSharePct": 13.2682,
      "top5SharePct": 44.0453,
      "tailSharePct": 5.451,
      "rankedModelCount": 77,
      "dailyLeaderCount": 5,
      "firstEntryTokenSharePct": 6.902,
      "publicAppTokensPerRequest": null,
      "publicAppRequests": null,
      "publicAppCount": null,
      "weightedIntelligenceIndex": null,
      "intelligenceCoveragePct": 24.5062,
      "standardCallCostUsd": 0.02631035128867585,
      "weightedInputPricePerMillionUsd": 1.4975231374532652,
      "weightedOutputPricePerMillionUsd": 7.556746609428795,
      "priceCoveragePct": 30.1587
    },
    {
      "month": "2025-07",
      "totalTokensT": 11.760259,
      "leaderModelId": "anthropic/claude-4-sonnet-20250522",
      "leaderModelLabel": "Claude 4 Sonnet (Reasoning)",
      "leaderSharePct": 17.404,
      "top5SharePct": 49.3692,
      "tailSharePct": 5.2742,
      "rankedModelCount": 93,
      "dailyLeaderCount": 2,
      "firstEntryTokenSharePct": 6.1624,
      "publicAppTokensPerRequest": 12544.994725402834,
      "publicAppRequests": 306378089,
      "publicAppCount": 100,
      "weightedIntelligenceIndex": 23.406880365185618,
      "intelligenceCoveragePct": 35.4082,
      "standardCallCostUsd": 0.03136501832414027,
      "weightedInputPricePerMillionUsd": 1.7427120150563613,
      "weightedOutputPricePerMillionUsd": 9.29193211571777,
      "priceCoveragePct": 36.2443
    },
    {
      "month": "2025-08",
      "totalTokensT": 14.972246,
      "leaderModelId": "anthropic/claude-4-sonnet-20250522",
      "leaderModelLabel": "Claude 4 Sonnet (Reasoning)",
      "leaderSharePct": 15.4361,
      "top5SharePct": 40.2205,
      "tailSharePct": 5.9365,
      "rankedModelCount": 78,
      "dailyLeaderCount": 2,
      "firstEntryTokenSharePct": 11.3776,
      "publicAppTokensPerRequest": 14031.340419678354,
      "publicAppRequests": 404761833,
      "publicAppCount": 100,
      "weightedIntelligenceIndex": 24.18725924577833,
      "intelligenceCoveragePct": 32.7752,
      "standardCallCostUsd": 0.030213964264450548,
      "weightedInputPricePerMillionUsd": 1.6746174381023156,
      "weightedOutputPricePerMillionUsd": 8.978526588951583,
      "priceCoveragePct": 33.6302
    },
    {
      "month": "2025-09",
      "totalTokensT": 21.420165,
      "leaderModelId": "x-ai/grok-code-fast-1",
      "leaderModelLabel": "Grok Code Fast 1",
      "leaderSharePct": 22.4297,
      "top5SharePct": 51.1431,
      "tailSharePct": 5.5428,
      "rankedModelCount": 81,
      "dailyLeaderCount": 3,
      "firstEntryTokenSharePct": 10.5999,
      "publicAppTokensPerRequest": 19123.179700783025,
      "publicAppRequests": 458666894,
      "publicAppCount": 100,
      "weightedIntelligenceIndex": 23.295405685830467,
      "intelligenceCoveragePct": 28.4301,
      "standardCallCostUsd": 0.027144321163202256,
      "weightedInputPricePerMillionUsd": 1.5024514081887523,
      "weightedOutputPricePerMillionUsd": 8.079871387543141,
      "priceCoveragePct": 29.2912
    },
    {
      "month": "2025-10",
      "totalTokensT": 22.346458,
      "leaderModelId": "x-ai/grok-code-fast-1",
      "leaderModelLabel": "Grok Code Fast 1",
      "leaderSharePct": 24.4433,
      "top5SharePct": 47.9548,
      "tailSharePct": 6.4726,
      "rankedModelCount": 77,
      "dailyLeaderCount": 1,
      "firstEntryTokenSharePct": 5.8249,
      "publicAppTokensPerRequest": 17251.821556462386,
      "publicAppRequests": 527675803,
      "publicAppCount": 100,
      "weightedIntelligenceIndex": 26.70764780424512,
      "intelligenceCoveragePct": 32.4465,
      "standardCallCostUsd": 0.028941813256307552,
      "weightedInputPricePerMillionUsd": 1.6170235517596974,
      "weightedOutputPricePerMillionUsd": 8.514385159140383,
      "priceCoveragePct": 33.9507
    },
    {
      "month": "2025-11",
      "totalTokensT": 26.560571,
      "leaderModelId": "x-ai/grok-code-fast-1",
      "leaderModelLabel": "Grok Code Fast 1",
      "leaderSharePct": 20.3285,
      "top5SharePct": 44.3617,
      "tailSharePct": 6.7022,
      "rankedModelCount": 85,
      "dailyLeaderCount": 2,
      "firstEntryTokenSharePct": 14.253,
      "publicAppTokensPerRequest": 17181.47707253043,
      "publicAppRequests": 583703119,
      "publicAppCount": 100,
      "weightedIntelligenceIndex": 27.88659179370118,
      "intelligenceCoveragePct": 25.7907,
      "standardCallCostUsd": 0.02926762582121478,
      "weightedInputPricePerMillionUsd": 1.6291020748019494,
      "weightedOutputPricePerMillionUsd": 8.651070048796859,
      "priceCoveragePct": 26.9932
    },
    {
      "month": "2025-12",
      "totalTokensT": 26.014738,
      "leaderModelId": "x-ai/grok-code-fast-1",
      "leaderModelLabel": "Grok Code Fast 1",
      "leaderSharePct": 10.3042,
      "top5SharePct": 31.1349,
      "tailSharePct": 8.9528,
      "rankedModelCount": 81,
      "dailyLeaderCount": 4,
      "firstEntryTokenSharePct": 12.2442,
      "publicAppTokensPerRequest": 13753.916626413527,
      "publicAppRequests": 552296476,
      "publicAppCount": 100,
      "weightedIntelligenceIndex": 27.910435751910427,
      "intelligenceCoveragePct": 28.1357,
      "standardCallCostUsd": 0.0230115221657623,
      "weightedInputPricePerMillionUsd": 1.324465586990253,
      "weightedOutputPricePerMillionUsd": 6.511244197239849,
      "priceCoveragePct": 29.616
    },
    {
      "month": "2026-01",
      "totalTokensT": 31.693294,
      "leaderModelId": "anthropic/claude-4.5-sonnet-20250929",
      "leaderModelLabel": "Claude 4.5 Sonnet (Reasoning)",
      "leaderSharePct": 8.6591,
      "top5SharePct": 32.8387,
      "tailSharePct": 8.0458,
      "rankedModelCount": 75,
      "dailyLeaderCount": 6,
      "firstEntryTokenSharePct": 1.6961,
      "publicAppTokensPerRequest": 13410.180970382393,
      "publicAppRequests": 642440119,
      "publicAppCount": 100,
      "weightedIntelligenceIndex": 29.125602806306382,
      "intelligenceCoveragePct": 29.992,
      "standardCallCostUsd": 0.023958649038183333,
      "weightedInputPricePerMillionUsd": 1.398440988097131,
      "weightedOutputPricePerMillionUsd": 6.649492771474687,
      "priceCoveragePct": 32.4351
    },
    {
      "month": "2026-02",
      "totalTokensT": 49.787155,
      "leaderModelId": "minimax/minimax-m2.5-20260211",
      "leaderModelLabel": "Minimax M2.5 20260211",
      "leaderSharePct": 10.9275,
      "top5SharePct": 36.8594,
      "tailSharePct": 6.4433,
      "rankedModelCount": 84,
      "dailyLeaderCount": 3,
      "firstEntryTokenSharePct": 24.1018,
      "publicAppTokensPerRequest": 24561.17281472649,
      "publicAppRequests": 716673871,
      "publicAppCount": 100,
      "weightedIntelligenceIndex": null,
      "intelligenceCoveragePct": 23.59,
      "standardCallCostUsd": 0.020358032963443205,
      "weightedInputPricePerMillionUsd": 1.1999476277258532,
      "weightedOutputPricePerMillionUsd": 5.572371124123129,
      "priceCoveragePct": 32.3716
    },
    {
      "month": "2026-03",
      "totalTokensT": 83.987846,
      "leaderModelId": "xiaomi/mimo-v2-pro-20260318",
      "leaderModelLabel": "Mimo V2 Pro 20260318",
      "leaderSharePct": 8.1796,
      "top5SharePct": 32.9976,
      "tailSharePct": 7.0912,
      "rankedModelCount": 83,
      "dailyLeaderCount": 4,
      "firstEntryTokenSharePct": 22.248,
      "publicAppTokensPerRequest": 29964.350624077386,
      "publicAppRequests": 1183597128,
      "publicAppCount": 100,
      "weightedIntelligenceIndex": 33.954742284393205,
      "intelligenceCoveragePct": 28.1065,
      "standardCallCostUsd": 0.02192789794867261,
      "weightedInputPricePerMillionUsd": 1.2898035577819005,
      "weightedOutputPricePerMillionUsd": 6.019908247235732,
      "priceCoveragePct": 31.1503
    },
    {
      "month": "2026-04",
      "totalTokensT": 97.430583,
      "leaderModelId": "qwen/qwen3.6-plus-04-02:free",
      "leaderModelLabel": "Qwen3.6 Plus 04 02 Free",
      "leaderSharePct": 6.4313,
      "top5SharePct": 26.3551,
      "tailSharePct": 9.0421,
      "rankedModelCount": 85,
      "dailyLeaderCount": 7,
      "firstEntryTokenSharePct": 19.2592,
      "publicAppTokensPerRequest": 32559.74296686708,
      "publicAppRequests": 1143509705,
      "publicAppCount": 100,
      "weightedIntelligenceIndex": 38.43825608170774,
      "intelligenceCoveragePct": 37.8134,
      "standardCallCostUsd": 0.02479003181063738,
      "weightedInputPricePerMillionUsd": 1.4502234316419162,
      "weightedOutputPricePerMillionUsd": 6.85853166281214,
      "priceCoveragePct": 40.4655
    },
    {
      "month": "2026-05",
      "totalTokensT": 122.961294,
      "leaderModelId": "deepseek/deepseek-v4-flash-20260423",
      "leaderModelLabel": "DeepSeek V4 Flash (Reasoning, Max Effort)",
      "leaderSharePct": 8.1755,
      "top5SharePct": 31.6934,
      "tailSharePct": 9.7833,
      "rankedModelCount": 89,
      "dailyLeaderCount": 4,
      "firstEntryTokenSharePct": 15.9308,
      "publicAppTokensPerRequest": 30740.668364905916,
      "publicAppRequests": 1222702474,
      "publicAppCount": 100,
      "weightedIntelligenceIndex": 41.42167002739347,
      "intelligenceCoveragePct": 59.1291,
      "standardCallCostUsd": 0.02495678506348433,
      "weightedInputPricePerMillionUsd": 1.4672867593793222,
      "weightedOutputPricePerMillionUsd": 6.855944979794069,
      "priceCoveragePct": 61.0141
    },
    {
      "month": "2026-06",
      "totalTokensT": 188.387679,
      "leaderModelId": "deepseek/deepseek-v4-flash-20260423",
      "leaderModelLabel": "DeepSeek V4 Flash (Reasoning, Max Effort)",
      "leaderSharePct": 10.162,
      "top5SharePct": 40.6716,
      "tailSharePct": 6.401,
      "rankedModelCount": 78,
      "dailyLeaderCount": 4,
      "firstEntryTokenSharePct": 13.2139,
      "publicAppTokensPerRequest": 36537.403988309365,
      "publicAppRequests": 1686167392,
      "publicAppCount": 100,
      "weightedIntelligenceIndex": 42.50879520582437,
      "intelligenceCoveragePct": 72.5368,
      "standardCallCostUsd": 0.022806230081626872,
      "weightedInputPricePerMillionUsd": 1.3478930816571786,
      "weightedOutputPricePerMillionUsd": 6.218199510036721,
      "priceCoveragePct": 73.7503
    }
  ],
  "taskMix": {
    "asOf": "2026-07-13",
    "windowDays": 7,
    "rows": [
      {
        "key": "agent",
        "label": "Agent",
        "tokenSharePct": 33.800000000000004,
        "requestSharePct": 13.100000000000001,
        "tokenIntensity": 2.5801526717557253
      },
      {
        "key": "code",
        "label": "Code",
        "tokenSharePct": 31.6,
        "requestSharePct": 10.2,
        "tokenIntensity": 3.0980392156862746
      },
      {
        "key": "general",
        "label": "General",
        "tokenSharePct": 27.700000000000003,
        "requestSharePct": 57.99999999999999,
        "tokenIntensity": 0.4775862068965518
      },
      {
        "key": "data",
        "label": "Data",
        "tokenSharePct": 6.800000000000001,
        "requestSharePct": 18.7,
        "tokenIntensity": 0.36363636363636365
      }
    ]
  },
  "modelTape": {
    "month": "2026-06",
    "rows": [
      {
        "modelId": "deepseek/deepseek-v4-flash-20260423",
        "label": "DeepSeek V4 Flash (Reasoning, Max Effort)",
        "tokenSharePct": 10.162,
        "intelligenceIndex": 40.3,
        "inputPricePerMillionUsd": 0.13899999999999998,
        "outputPricePerMillionUsd": 0.27799999999999997,
        "publicParametersB": null
      },
      {
        "modelId": "minimax/minimax-m3-20260531",
        "label": "MiniMax-M3",
        "tokenSharePct": 8.2481,
        "intelligenceIndex": 44.4,
        "inputPricePerMillionUsd": 0.3,
        "outputPricePerMillionUsd": 1.2,
        "publicParametersB": null
      },
      {
        "modelId": "xiaomi/mimo-v2.5-20260422",
        "label": "MiMo-V2.5",
        "tokenSharePct": 8.1991,
        "intelligenceIndex": 37.2,
        "inputPricePerMillionUsd": 0.39999999999999997,
        "outputPricePerMillionUsd": 2,
        "publicParametersB": null
      },
      {
        "modelId": "tencent/hy3-preview-20260421",
        "label": "Hy3",
        "tokenSharePct": 8.1019,
        "intelligenceIndex": 41.2,
        "inputPricePerMillionUsd": 0.06599999999999999,
        "outputPricePerMillionUsd": 0.26,
        "publicParametersB": null
      },
      {
        "modelId": "openrouter/owl-alpha",
        "label": "Owl Alpha",
        "tokenSharePct": 5.9603,
        "intelligenceIndex": null,
        "inputPricePerMillionUsd": null,
        "outputPricePerMillionUsd": null,
        "publicParametersB": null
      },
      {
        "modelId": "anthropic/claude-4.7-opus-20260416",
        "label": "Claude Opus 4.7 (Adaptive Reasoning, Max Effort)",
        "tokenSharePct": 4.8631,
        "intelligenceIndex": 53.5,
        "inputPricePerMillionUsd": 5.5,
        "outputPricePerMillionUsd": 27.5,
        "publicParametersB": null
      },
      {
        "modelId": "deepseek/deepseek-v4-pro-20260423",
        "label": "DeepSeek V4 Pro (Reasoning, Max Effort)",
        "tokenSharePct": 4.7202,
        "intelligenceIndex": 44.3,
        "inputPricePerMillionUsd": 1.74,
        "outputPricePerMillionUsd": 3.48,
        "publicParametersB": null
      },
      {
        "modelId": "anthropic/claude-4.6-sonnet-20260217",
        "label": "Claude Sonnet 4.6 (Adaptive Reasoning, Max Effort)",
        "tokenSharePct": 3.9704,
        "intelligenceIndex": 47.2,
        "inputPricePerMillionUsd": 3,
        "outputPricePerMillionUsd": 15,
        "publicParametersB": null
      },
      {
        "modelId": "anthropic/claude-4.8-opus-20260528",
        "label": "Claude Opus 4.8 (Adaptive Reasoning, Max Effort)",
        "tokenSharePct": 3.5239,
        "intelligenceIndex": 55.7,
        "inputPricePerMillionUsd": 5,
        "outputPricePerMillionUsd": 25,
        "publicParametersB": null
      },
      {
        "modelId": "stepfun/step-3.7-flash-20260528",
        "label": "Step 3.7 Flash",
        "tokenSharePct": 2.3558,
        "intelligenceIndex": 30.3,
        "inputPricePerMillionUsd": 0.19999999999999998,
        "outputPricePerMillionUsd": 1.15,
        "publicParametersB": null
      },
      {
        "modelId": "deepseek/deepseek-v3.2-20251201",
        "label": "DeepSeek V3.2 (Reasoning)",
        "tokenSharePct": 2.2239,
        "intelligenceIndex": 32,
        "inputPricePerMillionUsd": 1,
        "outputPricePerMillionUsd": 1,
        "publicParametersB": null
      },
      {
        "modelId": "google/gemini-3-flash-preview-20251217",
        "label": "Gemini 3 Flash Preview 20251217",
        "tokenSharePct": 2.2091,
        "intelligenceIndex": null,
        "inputPricePerMillionUsd": null,
        "outputPricePerMillionUsd": null,
        "publicParametersB": null
      }
    ]
  },
  "limitations": [
    "OpenRouter rankings cover one routing platform; daily top 50 plus the aggregated other row are not a global model market.",
    "Tokens use each upstream provider's tokenizer and are not perfectly comparable across model families.",
    "Tokens per request cover the returned top public apps; hidden/private apps and the long tail are outside that denominator.",
    "Historical intelligence is re-scored with the current Artificial Analysis index version; it is not a point-in-time benchmark vintage.",
    "Intelligence and price indices are suppressed below 25% of monthly platform Tokens.",
    "Standard-call cost applies current list prices to 10k input plus 1.5k output Tokens; it is not observed customer spend per request."
  ]
}
